import {useQuery} from 'react-query';
import decodeError from 'shared/util/decore-error';
import useApi from './use-api';
import {errorNotification} from 'shared/services/notification';

interface Props {
  url: string;
  queryKey?: any;
  params?: any;
  enabled?: boolean;
  extractData?: boolean;
  refetchInterval?: number | false;
  method?: string;
  data?: any;
  retry?: number | false;
  refetchOnWindowFocus?: boolean;
  headers?: any;
  staleTime?: number;
  refetchOnMount?: boolean;
  refetchOnReconnect?: boolean;
}

const useApiQuery = <T = any>({
  url,
  queryKey,
  params,
  refetchInterval,
  enabled = true,
  method = 'GET',
  retry = 3,
  refetchOnWindowFocus = true,
  headers,
  staleTime,
  refetchOnMount,
  refetchOnReconnect,
  ...props
}: Props) => {
  const api = useApi();

  const request = async () => {
    const response = await api({
      method,
      url,
      params,
      headers,
      data: props.data,
    });

    return response.data;
  };

  const getQueryKey = () => {
    if (params) return [queryKey ?? url, params];
    return [queryKey ?? url];
  };

  const {data: responseData, ...query} = useQuery(getQueryKey(), {
    queryFn: request,
    onError: (error) =>
      errorNotification({
        title: 'Erro ao buscar dados',
        message: decodeError(error),
      }),
    enabled,
    refetchInterval,
    retry,
    refetchOnWindowFocus,
    staleTime,
    refetchOnMount,
    refetchOnReconnect,
  });

  const {data, ...rest} = responseData ?? {};

  return {...query, data: data as T, extraData: rest};
};

export default useApiQuery;
